<template>
  <div class="container d-flex flex-row justify-center align-center">
    <v-row v-if="loading || errorModal">
      <loadingComponent
        @closeDialog="close($event)"
        :loadingProps="loading"
        :messageDialogeProps="messageDialoge"
        :dialogProps="dialog"
        :errorProps="errorModal"
      />
    </v-row>
    <v-card>
      <v-toolbar
        class="white--text"
        :style="{ background: $styles.background }"
      >
        <span class="pl-0">Rentrer une opportunité</span>
      </v-toolbar>
      <div class="d-flex flex-column">
        <v-stepper
          style="border-top-left-radius: 0px; border-top-right-radius: 0px"
          elevation="0"
          v-model="e1"
        >
          <v-stepper-header style="box-shadow: 0 0 0 transparent">
            <v-stepper-step
              :color="$colors[0]"
              :complete="e1 > 1"
              step="1"
              @click="e1 > 1 ? (e1 = 1) : (e1 = e1)"
            >
              Pro Ou Particulier
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :color="$colors[0]"
              :complete="e1 > 2"
              step="2"
              @click="e1 > 2 ? (e1 = 2) : (e1 = e1)"
            >
              {{
                typeClient == "Pro"
                  ? "Recherche Entreprise"
                  : "Recherche Particulier"
              }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :color="$colors[0]"
              :complete="e1 > 3"
              step="3"
              @click="e1 > 3 ? (e1 = 3) : (e1 = e1)"
            >
              {{
                typeClient == "Pro"
                  ? "Informations Entreprise"
                  : "Informations Particulier"
              }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :color="$colors[0]"
              :complete="e1 > 4"
              step="4"
              @click="e1 > 4 ? (e1 = 4) : (e1 = e1)"
            >
              Ajout Point(s)
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :color="$colors[0]" step="5">
              Ajout Fichier(s)
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items style="height: 10%">
            <v-stepper-content step="1">
              <v-card elevation="0" class="d-flex flex-row">
                <TabSlider v-model="typeClient">
                  <template v-slot="{ selectedTab }">
                    <div v-if="selectedTab === 'Pro'">Pro</div>
                    <div v-else>Particulier</div>
                  </template></TabSlider
                >
              </v-card>
              <v-btn
                @click="nextStep()"
                :color="$colors[0]"
                class="white--text mt-10"
                >Suivant</v-btn
              >
            </v-stepper-content>
            <v-stepper-content class="pa-4" step="2">
              <v-card elevation="0" class="d-flex flex-row">
                <v-row class="ma-2">
                  <v-col class="pa-0" cols="12" style="height: 35%">
                    <v-form v-if="typeClient == 'Pro'" ref="formSiret">
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="siret"
                            dense
                            :rules="[
                              $rules.required(`un siret valide`),
                              $rules.isSanitize,
                              $rules.isNumber,
                              $rules.compteurElecLength,
                            ]"
                            label="SIRET"
                            placeholder="SIRET"
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                    <v-form v-if="typeClient == 'Particulier'" ref="formSiret">
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="particulierEmail"
                            dense
                            label="Email"
                            :rules="[$rules.isEmail]"
                            placeholder="Email"
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card>
              <v-btn
                @click="
                  () => {
                    typeClient == 'Pro'
                      ? getSiretInformations()
                      : getParticulerInformations();
                  }
                "
                :color="$colors[0]"
                class="white--text mx-2"
                >Rechercher</v-btn
              >
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-form class="mt-4" ref="formInfo">
                <v-card elevation="0" class="mb-6 d-flex flex-row">
                  <v-row>
                    <v-col cols="12" sm="4" md="3" v-if="typeClient == 'Pro'">
                      <v-text-field
                        class="ma-0"
                        dense
                        outlined
                        label="Raison"
                        :rules="[
                          $rules.required(`un Raison valide`),
                          $rules.isSanitize,
                        ]"
                        disabled
                        v-model="societe.raison"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                      <v-text-field
                        class="ma-0"
                        dense
                        outlined
                        label="Adresse Postal"
                        :rules="[
                          $rules.required(`un Adresse Postal valide`),
                          $rules.isSanitize,
                        ]"
                        :disabled="typeClient=='Pro'"
                        v-model="societe.adressePostal"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                      <v-select
                        label="Civilite"
                        dense
                        outlined
                        :items="selectionGenre"
                        v-model="societe.civile"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                      <v-text-field
                        class="ma-0"
                        dense
                        outlined
                        label="Nom"
                        :rules="[
                          $rules.required(`un Nom valide`),
                          $rules.isSanitize,
                        ]"
                        v-model="societe.nom"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                      <v-text-field
                        class="ma-0"
                        dense
                        outlined
                        label="Prenom"
                        :rules="[
                          $rules.required(`un Prenom valide`),
                          $rules.isSanitize,
                        ]"
                        v-model="societe.prenom"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                      <v-text-field
                        class="ma-0"
                        dense
                        outlined
                        label="Email"
                        :rules="[
                          $rules.required(`un Email valide`),
                          $rules.isSanitiz,
                          valideEmail,
                        ]"
                        v-model="societe.adresseEmail"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                      <v-text-field
                        class="ma-0"
                        dense
                        outlined
                        label="N° Tele"
                        :rules="[
                          $rules.required(`un N° tele valide`),
                          $rules.isSanitize,
                          validePhoneNumber,
                        ]"
                        v-model="societe.numTele"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="3" v-if="typeClient=='Pro'">
                      <v-text-field
                        class="ma-0"
                        dense
                        outlined
                        label="Fonction"
                        :rules="[
                          $rules.required(`une Fonction valide`),
                          $rules.isSanitize,
                        ]"
                        v-model="societe.fonction"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                      <v-text-field
                        class="ma-0"
                        dense
                        outlined
                        :min="new Date().toISOString().split('T')[0]"
                        type="date"
                        label="Date Devis"
                        :rules="[
                          $rules.required(`un Date devis valide`),
                          $rules.isSanitize,
                        ]"
                        v-model="societe.dateDevis"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
              </v-form>
              <v-btn
                class="mr-2 white--text"
                :color="$colors[0]"
                @click="validateInfo()"
              >
                Valider
              </v-btn>
              <v-btn text @click="e1 = 1"> Annuler </v-btn>
            </v-stepper-content>
            <v-stepper-content step="4">
              <!-- UPLOAD Csv file to create pdls input -->
              <v-card elevation="0">
                
                <v-form ref="formFiles">
                  <div
                  class="my-3"
                    style="display: flex; justify-content: center; align-items: center"
                  >
                    <uploadFile
                      v-if="e1 == '4'"
                      :fileProps="pdlFile"
                      :fileType="'csv'"
                      :name="'Fichier PDLS'"
                      key="fileduploadcsv"
                      :maxNumberFileProps="maxNumberFile"
                      :fileRequired="fileRequired"
                      @maxNumberFile="1"
                      @FileData="retrievePdlFile($event)"
                    />
                    <!--<listFile
                      :isVisible="true"
                      :file="files[fichierChoisi]"
                      @remove="refreshListFiles($event, fichierChoisi)"
                    />-->
                  </div>
                  <div class="d-flex flex-row justify-center mb-3">
                    <v-btn
                      v-if="showFillComptuerInputsButtons"
                      @click="fillComptuerInputs()"
                      :color="$colors[0]"
                      class="white--text"
                    >
                      Remplir les champs
                    </v-btn>
                  </div>
                </v-form>
                <div
                  style="border: orange solid 1px; text-align: center"
                  v-if="error == true"
                >
                  <p style="color: orange">{{ errorAlertText }}</p>
                </div>
              </v-card>
              <v-card class="mb-12" height="300px;">
                <v-form ref="formValidePdls1">
                  <v-row>
                    <v-col cols="12">
                      <v-divider class="mt-2"></v-divider>
                      <p>Ajouter les PDL(s)</p>
                      <v-row v-for="(input, index) in inputsCompteur" :key="index">
                        <v-col cols="12" sm="12" md="12" lg="6" xl="6">
                          <v-text-field
                           
                            label="PDL"
                            v-model="input.selectedPdl"
                            :rules="[$rules.required(`un PDL valide`), $rules.compteurElecLength]"
                            @change="validateInput"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="6" xl="6">
                          <v-select
                            :items="typeCompteurItems"
                            label="Type de compteur"
                            v-model="input.selectedTypeCompteur"
                            :rules="[$rules.required(`un type de compteur valide`)]"
                            @change="validateInput"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <div class="d-flex flex-row justify-end">
                        <v-btn @click="addInput" class="me-2" style="background-color: #17a2b8; color: white; padding: 10px 24px;">
    <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn v-if="inputsCompteur.length > 1" @click="deleteInput"  class="ms-2" style="background-color: #f49236; color: white; padding: 10px 24px;">
                          <v-icon>mdi-minus</v-icon>
                        </v-btn>
                      </div>
                  </v-col>
                </v-row>
                </v-form>
              </v-card>
              <v-btn
                class="mr-2 white--text"
                :color="$colors[0]"
                @click="verifierListeCompteurExiste()"
              >
                Valider
              </v-btn>
              <v-btn text @click="e1 = 1"> Annuler </v-btn>
            </v-stepper-content>
            <v-stepper-content step="5">
              <v-card elevation="0">
                <v-combobox
                  v-model="fichierChoisi"
                  :items="choixFichiers"
                  outlined
                  dense
                ></v-combobox>
                <v-form ref="formFiles">
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <uploadFile
                      v-if="e1 == '5'"
                      :fileProps="files[fichierChoisi]"
                      :fileType="'autre'"
                      key="fileduploadautre"
                      :name="fichierChoisi"
                      :maxNumberFileProps="maxNumberFile"
                      :fileRequired="fileRequired"
                      @maxNumberFile="4"
                      @FileData="retrieveFile($event, fichierChoisi)"
                    />
                    <!--<listFile
                      :isVisible="true"
                      :file="files[fichierChoisi]"
                      @remove="refreshListFiles($event, fichierChoisi)"
                    />-->
                  </div>
                </v-form>
                <div
                  style="border: orange solid 1px; text-align: center"
                  v-if="error == true"
                >
                  <p style="color: orange">{{ errorAlertText }}</p>
                </div>
              </v-card>
              <v-btn
                class="white--text mr-2"
                :color="$colors[0]"
                @click="submit()"
              >
                Finaliser
              </v-btn>
              <v-btn text @click="e1 = 2"> Annuler </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <!---->
      </div>
    </v-card>
  </div>
</template>
<script>
import loadingComponent from "./components/Loading";
import listFile from "./components/listFile.vue";
import uploadFile from "./components/uploadFile.vue";
import TabSlider from "@/components/TabSlider.vue";
import axios from "@/plugins/axios";
export default {
  name: "NouvelleOpportuniteSolarCollectif",
  components: {
    uploadFile: uploadFile,
    listFile: listFile,
    loadingComponent: loadingComponent,
    TabSlider
  },
  data() {
    return {
      //
      responseStatus: 0,
      dialog: false,
      loading: false,
      messageDialoge: "",
      typeClient: "Pro",
      particulierEmail: "",
      errorModal: false,
      showFillComptuerInputsButtons: false,
      //
      pdlItems: ['autoCollective&Individuelle', 'production', 'consommation','autoCollective'],
      typeCompteurItems: ['autoCollective&Individuelle', 'production', 'consommation','autoCollective'],
      inputsCompteur: [
        { selectedPdl: null, selectedTypeCompteur: null }
      ],
      num_comp: [],
      isLoading: false,
      files: {
        ACD: [],
        Contrat: [],
        Facture: [],
        Plans: [],
      },
      pdlFile: [],
      maxNumberFile: 4,
      fileRequired: false,
      choixFichiers: ["ACD", "Facture", "Contrat", "Plans"],
      fichierChoisi: "ACD",
      fichierPdlChoisi: "Fichier PDL",
      choixFichiersPdl: ["Fichier PDL"],
      e1: 1,
      selectionGenre: ["Monsieur", "Madame"],
      siret: "",
      societe: {
        Siret: this.siret,
        nom: "",
        prenom: "",
        adresseEmail: "",
        numTele: "",
        fonction: "",
        codeNaf: "",
        codeInsee: "",
        raison: "",
        adressePostal: "",
        codePostal: "",
        commune: "",
        voie: "",
        statusSociete: "",
        RCS: "",
        TVA: "",
        civile: "",
        formJu: "",
        dateDevis: "",
      },
      errorAlertText: "",
      error: false,
    };
  },
  methods: {
    ajouterCompteur() {
      this.num_comp.push("");
    },
    deleteCompteur(index) {
      this.num_comp.splice(index, 1);
    },
    formatInputsCompteur() {
    return this.inputsCompteur
      .map(input => `${input.selectedPdl},${input.selectedTypeCompteur}`)
      .join(';');
    },
    supprimerCompteur(index) {
      this.num_comp.splice(index, 1);
    },
    close(event) {
      this.dialog = event;
      this.errorModal = event;
      if (this.responseStatus === 401) {
        this.$store.dispatch("logout");
      }
    },
    clickMenu(clikedElement) {
      this.e1 = clikedElement;
    },
    addInput() {
    this.inputsCompteur.push({ selectedPdl: null, selectedTypeCompteur: null });
    },
    deleteInput() {
    this.inputsCompteur.pop();
    },
    changeCompteurSelected() {},
    async submit() {
      if (
        this.files["ACD"].length === 0 &&
        this.files["Contrat"].length === 0 &&
        this.files["Facture"].length === 0
      ) {
        this.dialog = true;
        this.loading = false;
        this.messageDialoge = "Sélectionnez au moins une fichier!";
        this.errorModal = true;
      } else {
        this.dialog = true;
        this.loading = true;
        this.messageDialoge = "";
        this.errorModal = false;
        var formData = new FormData();
        if(this.typeClient=="Pro"){
          formData.append("societe", JSON.stringify(this.societe));
        }else if(this.typeClient=="Particulier"){
          formData.append("dataParticulier", JSON.stringify(this.societe));
        }
        formData.append("dateDevis",this.societe.dateDevis)
        formData.append("typeClient",this.typeClient)
        formData.append("PDLs", this.formatInputsCompteur());
        formData.append("token", this.$cookies.get("token"));
        for (var i = 0; i < this.files.Contrat.length; i++) {
          //lesDonner["Contrat"+i] = this.files.Contract[i]
          formData.append("Contrat" + i, this.files.Contrat[i]);
        }
        for (var i = 0; i < this.files.ACD.length; i++) {
          //lesDonner["ACD"+i] = this.files.ACD[i]
          formData.append("ACD" + i, this.files.ACD[i]);
        }
        for (var i = 0; i < this.files.Facture.length; i++) {
          //lesDonner["Facture"+i] = this.files.Facture[i]
          formData.append("Facture" + i, this.files.Facture[i]);
        }
        for (var i = 0; i < this.files.Plans.length; i++) {
          formData.append("Plans" + i, this.files.Plans[i]);
        }
        await axios({
          url:
            process.env.VUE_APP_URL_API_CLIENT +
            "ajouterDemandeDeCotationSolarCollectif/",
          method: "POST",
          data: formData,
        })
          .then((res) => {
            if (res.data.result == true) {
              this.dialog = true;
              this.loading = false;
              this.messageDialoge = "Demande de cotation ajouter";
              this.errorModal = false;
            } else {
              this.dialog = true;
              this.loading = false;
              this.messageDialoge = res.data.message;
              this.errorModal = true;
            }
          })
          .catch((err) => {
            this.dialog = true;
            this.loading = false;
            this.messageDialoge = "une erreur technique est survenue";
            this.errorModal = true;
          });
      }
    },
    refreshListFiles(file, typeFichier) {
      this.files[typeFichier] = file;
      this.maxNumberFile = 4;
    },
    CheckNumberFile(e) {
      this.maxNumberFile = e;
    },
    retrieveFile(event, typeFichier) {
      this.files[typeFichier] = event;
    },
    retrievePdlFile(event) {
      this.pdlFile = event;
      // read the csv file and fill the inputsCompteur with the data
      // file has the columns pdl and typeCompteur

      // check if the file  has the right columns:
     
      const reader = new FileReader();
      reader.readAsText(this.pdlFile[0]);
      let isAllValid = true;
      reader.onload = (e) => {
        let lines = e.target.result.split("\n");
        lines = lines.filter(line => line.trim() !== '');
        const headers = lines[0].trim().split(",");
        const typeCompteurIndex = headers.indexOf("typeCompteur");
        const validTypes = ['autoCollective&Individuelle', 'production', 'consommation','autoCollective'];
        for (let i = 1; i < lines.length; i++) {
          const line = lines[i].trim().split(",");
          if (line.length > 1) {
            if (!validTypes.includes(line[typeCompteurIndex])) {
              this.dialog = true;
              this.loading = false;
              this.messageDialoge = "le type de compteur n'est pas valide";
              this.errorModal = true;
              isAllValid = false;
              break;
            }
          }
        }
       
        if (headers.includes("pdl") && headers.includes("typeCompteur") && isAllValid) {
          this.showFillComptuerInputsButtons = true;
        }else{
          this.showFillComptuerInputsButtons = false;
        }
      };


      
    },
    fillComptuerInputs() {
      const reader = new FileReader();
      reader.readAsText(this.pdlFile[0]);
      reader.onload = (e) => {
        let lines = e.target.result.split("\n");
        console.log("lines",lines);
        lines = lines.filter(line => line.trim() !== '');
        const headers = lines[0].trim().split(",");
        const pdlIndex = headers.indexOf("pdl");
        const typeCompteurIndex = headers.indexOf("typeCompteur");
        console.log("pdlIndex",pdlIndex);
        console.log("typeCompteurIndex",typeCompteurIndex);
        const newInputsCompteur = [];
        for (let i = 1; i < lines.length; i++) {
          const line = lines[i].trim().split(",");
          console.log("line",line);
          console.log("line[typeCompteurIndex]",line[typeCompteurIndex]);

          if (line.length > 1) {
            newInputsCompteur.push({
              selectedPdl: line[pdlIndex],
              selectedTypeCompteur: line[typeCompteurIndex],
            });
          }
        }
        this.inputsCompteur = newInputsCompteur;
      };
    },
    async nextStep() {
      this.e1 = this.e1 + 1;
    },
    async getParticulerInformations() {
      if (this.$refs.formSiret.validate()) {
        this.dialog = true;
        this.loading = true;
        this.messageDialoge = "";
        this.errorModal = false;
        await axios({
          url:
            process.env.VUE_APP_URL_API_CLIENT +
            "get_ProfileParticulier_information/",
          method: "POST",
          data: {
            token: this.$cookies.get("token"),
            email: this.particulierEmail,
          },
        })
          .then(async (response) => {
            let responseData = response.data;
            this.responseStatus = response.status;
            this.loading = false;
            this.dialog = true;
            if (this.responseStatus === 200) {
              switch (responseData.result) {
                case true:
                  this.dialog = false;
                  this.messageDialoge = "";
                  this.societe = responseData.data;
                  this.adressePostalDisabled = true;
                  this.e1 = this.e1 + 1;
                  this.errorModal = false;
                  break;
                case false:
                  this.e1 = this.e1 + 1;
                  this.societe.adresseEmail = this.particulierEmail;
                  this.adressePostalDisabled = false;
                  break;
                default:
                  break;
              }
            } else if (this.responseStatus === 401) {
              this.messageDialoge = responseData.result;
              this.errorModal = true;
            } else {
              this.messageDialoge = data.result;
              this.errorModal = true;
            }
          })
          .catch((err) => {
            this.dialog = true;
            this.loading = false;
            this.messageDialoge = "une erreur technique est survenue";
            this.errorModal = true;
          });
      }
    },
    async getSiretInformations() {
      if (this.$refs.formSiret.validate()) {
        this.dialog = true;
        this.loading = true;
        this.messageDialoge = "";
        this.errorModal = false;
        await axios({
          url: process.env.VUE_APP_URL_API_CLIENT + "getSiretInformations/",
          method: "POST",
          data: {
            token: this.$cookies.get("token"),
            siret: this.siret,
          },
        })
          .then(async (response) => {
            let responseData = response.data;
            this.responseStatus = response.status;
            this.loading = false;
            this.dialog = true;
            if (this.responseStatus === 200) {
              switch (responseData.result) {
                case true:
                  this.dialog = false;
                  this.messageDialoge = "";
                  this.societe = responseData.data;
                  this.e1 = this.e1 + 1;
                  this.errorModal = false;
                  break;
                case false:
                  this.messageDialoge = "Verifer que votre siret est correct";
                  this.errorModal = true;
                  break;
                default:
                  break;
              }
            } else if (this.responseStatus === 401) {
              this.messageDialoge = responseData.result;
              this.errorModal = true;
            } else {
              this.messageDialoge = data.result;
              this.errorModal = true;
            }
          })
          .catch((err) => {
            this.dialog = true;
            this.loading = false;
            this.messageDialoge = "une erreur technique est survenue";
            this.errorModal = true;
          });
      }
    },
    validateInfo() {
      if (this.$refs.formInfo.validate()) {
        this.e1 = this.e1 + 1;
      }
    },
    /*async recherchePointes() {
      this.dialog = true;
      this.loading = true;
      this.messageDialoge = "";
      this.errorModal = false;
      if (this.$refs.formRecherchePdls.validate()) {
        await fetch(process.env.VUE_APP_URL_API_CLIENT + "getListeDesPoints/", {
          method: "POST",
          body: JSON.stringify({
            adresseUser: this.societe.adressePostal,
            codeInsee: this.societe.codeInsee,
            raison: this.societe.raison,
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (!("error" in data) && !("errorPostal" in data)) {
              this.listeCompteurs = data.listCompteur;
              this.dialog = false;
              this.loading = false;
              this.messageDialoge = "";
              this.errorModal = false;
            } else {
              this.listeCompteurs = data.listCompteur;
              this.dialog = true;
              this.loading = false;
              this.messageDialoge = "Il n'existe aucune PDL reliée à cette adresse.";
              this.errorModal = true;
            }
          })
          .catch((err) => {
            this.dialog = true;
            this.loading = false;
            this.messageDialoge = "une erreur technique est survenue";
            this.errorModal = true;
          });
      }
    },*/
    async verifierListeCompteurExiste() {
      if (this.inputsCompteur) {
        this.dialog = true;
        this.loading = true;
        this.messageDialoge = "";
        this.errorModal = false;
        if (this.$refs.formValidePdls1.validate()) {
          var formDonne = new FormData();
          formDonne.append("PDLS", this.formatInputsCompteur());
          await axios({
            url:
              process.env.VUE_APP_URL_API_CLIENT +
              "verifierListeCompteurExisteSolar/",
            method: "POST",
            data: formDonne,
          })
            .then((response) => {
              var data = response.data;
              if (data["result"] == "valide") {
                this.dialog = false;
                this.loading = false;
                this.messageDialoge = "";
                this.errorModal = false;
                this.e1 = this.e1 + 1;
              } else {
                this.dialog = true;
                this.loading = false;
                this.messageDialoge =
                  "le compteur n°" + data.compteurError + " n'existe pas";
                this.errorModal = true;
              }
            })
            .catch((err) => {
              this.dialog = true;
              this.loading = false;
              this.messageDialoge = "une erreur technique est survenue";
              this.errorModal = true;
            });
        }
      } else {
        this.dialog = true;
        this.loading = false;
        this.messageDialoge = "Sélectionnez au moins un compteur!";
        this.errorModal = true;
      }
    },
  },
  computed: {
    valideEmail() {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      if (emailPattern.test(this.societe.adresseEmail)) {
        return true;
      } else {
        return "Email invalide";
      }
    },
  
    validePhoneNumber() {
      // phone numver pattern is a string that contains 10 numeric digits starting with 0
      const phonePattern = /^\d{10}$/;
      if (phonePattern.test(this.societe.numTele)) {
        return true;
      } else {
        return "Numéro de téléphone invalide";
      }
    },
  },
};
</script>
<style scoped>
.container {
  height: 100%;
}
</style>
